import React, { useMemo } from 'react';
import { Table, Alert } from 'reactstrap';
import { Calories_Data } from '../constants';

const CaloriesTable = ({ gender, lifestyle, ageGroupMin, ageGroupMax }) => {
  const matchedData = useMemo(() => {
    return Calories_Data.find((item) => {
      const ageMatch = ageGroupMin >= item.ageGroupMin && ageGroupMax <= item.ageGroupMax;

      const genderMatch = item.gender === 0 || item.gender === gender;

      const lifestyleMatch = item.lifestyle == null || item.lifestyle === lifestyle;

      return ageMatch && genderMatch && lifestyleMatch;
    });
  }, [gender, lifestyle, ageGroupMin, ageGroupMax]);

  if (!matchedData) {
    return <Alert color="warning">No calorie data found for the selected criteria.</Alert>;
  }

  const totalCalories = matchedData.required_Calories;
  const variationPercent = parseInt(matchedData.allowed_Variation, 10) || 0;
  const variationAmount = Math.round((totalCalories * variationPercent) / 100);
  const minCalories = totalCalories - variationAmount;
  const maxCalories = totalCalories + variationAmount;

  return (
    <div className="mt-3 bg-white p-3 rounded border">
      <Table bordered striped responsive className="mb-0">
        <thead className="table-light">
          <tr>
            <th>Category</th>
            <th>Calories (kcal)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Total Required Calories</strong>
            </td>
            <td>
              <strong>
                {totalCalories} ({minCalories} – {maxCalories})
              </strong>
            </td>
          </tr>

          <tr>
            <td>Allowed Variation</td>
            <td>{matchedData.allowed_Variation}</td>
          </tr>

          <tr>
            <td>Breakfast (25%)</td>
            <td>{matchedData['Breakfast (25%)']}</td>
          </tr>

          <tr>
            <td>Morning Snack (10%)</td>
            <td>{matchedData['Mid-Morning (10%)']}</td>
          </tr>

          <tr>
            <td>Lunch (30%)</td>
            <td>{matchedData['Lunch (30%)']}</td>
          </tr>

          <tr>
            <td>Evening Snack (10%)</td>
            <td>{matchedData['Snacks (10%)']}</td>
          </tr>

          <tr>
            <td>Dinner (25%)</td>
            <td>{matchedData['Dinner (25%)']}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default CaloriesTable;
